import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  if (location.pathname === '/login' || location.pathname === '/signup') return null;

  return (
    <section className="p-6 md:p-12 bg-primary text-white">
      <div className="container mx-auto mb-16 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-12">

        <div className="flex flex-col">
          <a href='/'><img loading="lazy" src="/logo2.png" alt="Logo" className="mb-6" /></a>
          <p className="text-white overflow-wrap">
            Our consultation service is completely free and designed to save you time and effort. Fill out the form above, and one of our AI matchmaking experts will get in touch.
          </p>
        </div>

        <div className="flex flex-col space-y-8">
          <h4 className="text-2xl font-bold">Links</h4>
          <ul className="space-y-4">
            <li><a href="/about" className="hover:underline">About Us</a></li>
            <li><a href="/blogs" className="hover:underline">Blogs</a></li>
            <li><a href="/newsletter" className="hover:underline">Newsletter</a></li>
            <li><a href="/contact" className="hover:underline">Contact Us</a></li>
          </ul>
        </div>

        <div className="flex flex-col space-y-8">
          <h4 className="text-2xl font-bold">Legal</h4>
          <ul className="space-y-4">
            <li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
            <li><a href="/terms-of-service" className="hover:underline">Terms of Service</a></li>
            <li><a href="/cookie-policy" className="hover:underline">Data Protection</a></li>
          </ul>
        </div>

        <div className="flex flex-col space-y-8">
          <h4 className="text-2xl font-bold">Services</h4>
          <ul className="space-y-4">
            <li><a href="/consultation" className="hover:underline">CRM Setup</a></li>
            <li><a href="/automation" className="hover:underline">Automation</a></li>
            <li><a href="/automation-report" className="hover:underline">Automation Report</a></li>
          </ul>
        </div>

        <div className="flex flex-col space-y-8">
          <h4 className="text-2xl font-bold">Contact Details</h4>
          <ul className="space-y-4">
            <li className="font-bold">
              Telephone: <a href="tel:+1234567890" className="font-normal hover:underline">833.374.8915</a>
            </li>
            <li className="font-bold">
              Email: <a href="mailto:support@aiagencydirectory.com" className="font-normal hover:underline">support@aiagencydirectory.com</a>
            </li>
            <li className="font-bold">
              Address: <span className="font-normal">220 Sawgrass Dr Palos Heights, IL</span>
            </li>

            <li className="flex space-x-16 text-2xl">
              <a href="https://youtube.com/@theshahpodcast?si=TqHsa3i1dE732tS3" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="https://www.linkedin.com/company/ai-agency-directory/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a href="https://www.instagram.com/aiagencydirectory?igsh=dWcwdnBoemkybTk4&utm_source=qr" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
          </ul>
        </div>

      </div>

      <p className="text-center text-white mt-16">
        Copyright 2024 AI Agency Directory | All Rights Reserved
      </p>
    </section>
  );
};

export default Footer;
